import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import Moment from 'react-moment'
class EventCompaniesListV2 extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    isEditing: false,
    categoryId: null,
  }

  componentDidMount() {
    if (this.props?.match?.params?.id) {
      this.state.setState(
        {
          categoryId: this.props.match.params.id,
        },
        () => {
          this.getCategoryData(this.props.match.params.id)
        }
      )
    }
  }

  getCategoryData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/event-categories/list-top-event-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          const matchItem = res?.data?.data?.filter((itm) => itm?.id === id)

          if (matchItem?.length > 0) {
            const itm = matchItem[0]
            this.dashbord(itm.category_id)

            this.setState({
              ...itm,
            })
            this.setState({ Edit: true })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  dashbord = async (id) => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/event-companies/list-event-companies-v2/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Products_data: res.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, isActive) => {
    var that = this
    var data = {
      id: id,
      is_active: isActive,
    }
    await axios
      .put(Constant.getAPI() + '/event-companies/update-company-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.dashbord()
        }
      })
      .catch((err) => {
        that.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'company_img_url',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (company_img_url) => {
            return (
              <div>
                {company_img_url !== null ? (
                  <div>
                    {company_img_url?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                              ? Constant.getImage() + company_img_url
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                            ? Constant.getImage() + company_img_url
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      company_img_url !== undefined && company_img_url !== null && company_img_url !== {}
                        ? Constant.getImage() + company_img_url
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'company_name_en',
        label: 'Company Name: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return <>{date || '--'}</>
          },
        },
      },
      {
        name: 'company_name_ar',
        label: 'Comapny Name: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return <>{date || '--'}</>
          },
        },
      },
      {
        name: 'company_description_en',
        label: `Company Description: English`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return <>{date ? date.substring(0, 50) + '...' : '--'}</>
          },
        },
      },
      {
        name: 'company_description_ar',
        label: `Company Description: Arabic`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return <>{date ? date.substring(0, 50) + '...' : '--'}</>
          },
        },
      },
      {
        name: 'commission',
        label: 'Commission',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'company_short_name_en',
        label: 'Company Short Name: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'company_short_name_ar',
        label: 'Company Short Name: Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'updatedAt',
        label: 'Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'updatedAt',
        label: 'Time(hrs:min:sec)',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="HH:mm:ss">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'View Events',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/view-event-company/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Events "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Event Company List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Company List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`Event Company List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventCompaniesListV2
